<div class="modal-dialog ios-upload-dialog-container">
  <div class="modal-content" cdkTrapFocus>
    <div class="goreact-modal-header">
      <h4 class="modal-title">{{'ios-upload-dialog_title' | translate}}</h4>
      <button type="button" class="close-btn" (click)="close()" [attr.aria-label]="'common_close' | translate">
        <i class="ficon-app-x"></i>
      </button>
    </div>
    <div class="goreact-modal-body">
      <div class="image-container">
        @if (!imageLoaded) {
          <div class="skeleton-loader">
            <i class="ficon-spinner ficon-spin"></i>
          </div>
        }
        <img
          src="{{iosVersion >= 18 ? 'https://staticassets.goreact.com/ios-18.gif' : 'https://staticassets.goreact.com/ios-17.gif'}}"
          alt="image showing how to change the format on iOS to current to avoid video compression"
          (load)="imageLoaded = true"
          [class.hidden]="!imageLoaded" />
      </div>
    </div>
    <div class="goreact-modal-footer">
      <a
        href="https://support.echo360.com/hc/en-us/articles/38604331326093-Troubleshooting-iOS-Uploads"
        target="_blank"
        rel="noopener noreferrer"
      translate="common_need-more-help"></a>
      <button class="primary-btn" (click)="close()" translate="common_close"></button>
    </div>
  </div>
</div>
